import React from "react";
import { useField } from "formik";

import styles from "./Checkbox.module.scss";

function Checkbox({ children, ...props }) {
  const [field, meta] = useField(props, "checkbox");

  return (
    <div className={styles.container}>
      <label className={styles.inputWrapper}>
        <input
          type="checkbox"
          {...props}
          {...field}
          checked={field.value}
        ></input>

        {children}
      </label>

      {/* {meta.touched && meta.error ? (
                <div className={styles.errorText}>{meta.error}</div>
            ) : null} */}
    </div>
  );
}

export default Checkbox;
